function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M256,162.133c2.263,0.001,4.434-0.898,6.035-2.499c1.6-1.6,2.499-3.771,2.499-6.035V85.333 c0-4.713-3.82-8.533-8.533-8.533s-8.533,3.82-8.533,8.533V153.6c-0.001,2.263,0.898,4.434,2.499,6.035 C251.566,161.235,253.737,162.134,256,162.133z"
}), React.createElement("path", {
  d: "M494.933,93.867h-17.067V59.733c-0.011-9.421-7.646-17.056-17.067-17.067H339.002C319.837,15.888,288.93,0,256,0 c-32.93,0-63.837,15.888-83.002,42.667H51.2c-9.421,0.011-17.056,7.645-17.067,17.067v34.133H17.067 C7.645,93.877,0.011,101.512,0,110.933V460.8c0.011,9.421,7.645,17.056,17.067,17.067h185.175C212.033,498.7,232.98,512,256,512 s43.967-13.3,53.758-34.133h185.175c9.421-0.011,17.056-7.645,17.067-17.067V110.933 C511.989,101.512,504.355,93.877,494.933,93.867z M348.968,59.733H460.8v281.6H307.2c-16.07-0.002-31.458,6.494-42.667,18.01 V204.368c33.265-2.693,63.115-21.473,79.941-50.295C361.3,125.251,362.978,90.024,348.968,59.733z M307.2,401.067h153.6v25.6 H264.533v-25.6c0.028-23.553,19.114-42.639,42.667-42.667h153.6V384H307.2c-4.713,0-8.533,3.821-8.533,8.533 C298.667,397.246,302.487,401.067,307.2,401.067z M256,17.067c47.128,0,85.333,38.205,85.333,85.333S303.128,187.733,256,187.733 s-85.333-38.205-85.333-85.333C170.721,55.294,208.894,17.121,256,17.067z M51.2,59.733h111.832 c-14.01,30.291-12.333,65.517,4.493,94.34c16.826,28.822,46.676,47.602,79.941,50.295v154.975 c-11.208-11.516-26.596-18.012-42.667-18.01H51.2V59.733z M51.2,401.067h153.6c4.713,0,8.533-3.821,8.533-8.533 c0-4.713-3.821-8.533-8.533-8.533H51.2v-25.6h153.6c23.553,0.028,42.639,19.114,42.667,42.667v25.6H51.2V401.067z M494.933,460.8 H304.217c-0.094,0-0.171,0.05-0.265,0.053c-0.604,0.054-1.201,0.174-1.779,0.359c-1.008,0.09-1.957,0.516-2.693,1.211 c-0.958,0.465-1.731,1.241-2.192,2.201c-0.396,0.516-0.729,1.078-0.993,1.673c-0.033,0.087-0.106,0.144-0.138,0.232 c-6.013,17.022-22.105,28.404-40.158,28.404c-18.053,0-34.145-11.382-40.158-28.404c-0.031-0.089-0.104-0.145-0.138-0.232 c-0.259-0.58-0.583-1.129-0.967-1.635c-0.44-0.939-1.184-1.703-2.112-2.167c-0.416-0.343-0.865-0.645-1.339-0.902 c-0.446-0.159-0.905-0.28-1.371-0.362c-0.608-0.199-1.237-0.326-1.875-0.379c-0.092-0.003-0.167-0.052-0.258-0.052H17.067 V110.933h17.067v315.733c0.011,9.421,7.645,17.056,17.067,17.067h409.6c9.421-0.011,17.056-7.645,17.067-17.067V110.933h17.067 V460.8z"
}), React.createElement("path", {
  d: "M341.333,204.8c-0.001,2.263,0.898,4.434,2.499,6.035c1.6,1.6,3.771,2.499,6.035,2.499H435.2 c4.713,0,8.533-3.821,8.533-8.533s-3.82-8.533-8.533-8.533h-85.333c-2.263-0.001-4.434,0.898-6.035,2.499 C342.232,200.366,341.333,202.537,341.333,204.8z"
}), React.createElement("path", {
  d: "M435.2,238.933H315.733c-4.713,0-8.533,3.82-8.533,8.533s3.82,8.533,8.533,8.533H435.2c4.713,0,8.533-3.82,8.533-8.533 S439.913,238.933,435.2,238.933z"
}), React.createElement("path", {
  d: "M435.2,281.6H315.733c-4.713,0-8.533,3.82-8.533,8.533s3.82,8.533,8.533,8.533H435.2c4.713,0,8.533-3.82,8.533-8.533 S439.913,281.6,435.2,281.6z"
}), React.createElement("path", {
  d: "M76.8,213.333h85.333c4.713,0,8.533-3.821,8.533-8.533s-3.82-8.533-8.533-8.533H76.8c-4.713,0-8.533,3.82-8.533,8.533 S72.087,213.333,76.8,213.333z"
}), React.createElement("path", {
  d: "M76.8,256h119.467c4.713,0,8.533-3.82,8.533-8.533s-3.82-8.533-8.533-8.533H76.8c-4.713,0-8.533,3.82-8.533,8.533 S72.087,256,76.8,256z"
}), React.createElement("path", {
  d: "M196.267,281.6H76.8c-4.713,0-8.533,3.82-8.533,8.533s3.82,8.533,8.533,8.533h119.467c4.713,0,8.533-3.82,8.533-8.533 S200.979,281.6,196.267,281.6z"
}), React.createElement("path", {
  d: "M256,59.733c2.263,0.001,4.434-0.898,6.035-2.499c1.6-1.6,2.499-3.771,2.499-6.035v-8.533 c0-4.713-3.82-8.533-8.533-8.533s-8.533,3.82-8.533,8.533V51.2c-0.001,2.263,0.898,4.434,2.499,6.035 C251.566,58.835,253.737,59.734,256,59.733z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgNavMenuRulesIcon = function SvgNavMenuRulesIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNavMenuRulesIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-menu-rules-icon.6e4dded0.svg";
export { ForwardRef as ReactComponent };